var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "custom-callout",
        {
          attrs: { controlled: "", "has-toggle": "", opened: _vm.value.opened },
          on: {
            "click:open": function($event) {
              return _vm.toggle()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _c("div", { staticClass: "bg-secondary-3 p-2" }, [
                    _vm.areTabsVisible
                      ? _c(
                          "div",
                          { staticClass: "bg-white p-2 c-tabs" },
                          [
                            _c(
                              "b-tabs",
                              {
                                attrs: {
                                  "active-nav-item-class":
                                    "mipe-tab font-weight-bold text-mipe-orange mipe-active-tab",
                                  "active-tab-class": "",
                                  "content-class": "mt-3",
                                  "nav-class": "mipe-tab",
                                  "no-nav-style": true
                                },
                                model: {
                                  value: _vm.currentIndexTab,
                                  callback: function($$v) {
                                    _vm.currentIndexTab = $$v
                                  },
                                  expression: "currentIndexTab"
                                }
                              },
                              [
                                _c(
                                  "b-tab",
                                  {
                                    attrs: {
                                      active:
                                        _vm.currentIndexTab ===
                                        _vm.tabValue.History,
                                      title: "Historial de Estatus"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onActiveTab(
                                          _vm.tabValue.History
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("batch-history", {
                                      attrs: { item: _vm.value }
                                    })
                                  ],
                                  1
                                ),
                                _c("b-tab", {
                                  attrs: {
                                    active:
                                      _vm.currentIndexTab ===
                                      _vm.tabValue.Documents,
                                    title: "Documentos"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onActiveTab(
                                        _vm.tabValue.Documents
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-between w-100"
            },
            [
              _c("div", { staticClass: "w-100" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "row d-flex align-items-center py-2 pr-3 col-12"
                  },
                  [
                    _c("div", { staticClass: "col-12 col-md" }, [
                      _c("div", { staticClass: "data-name" }, [
                        _vm._v("Estatus:")
                      ]),
                      _c(
                        "div",
                        [
                          _c("custom-balloon", {
                            attrs: {
                              "background-color": _vm.value.status.color,
                              dot: "",
                              text: _vm.value.status.name
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "col-12 col-md" }, [
                      _c("div", { staticClass: "data-name" }, [
                        _vm._v("Número de Batch:")
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm._f("empty")(_vm.value.number)))
                      ])
                    ]),
                    _c("div", { staticClass: "col-12 col-md" }, [
                      _c("div", { staticClass: "data-name" }, [
                        _vm._v("Fecha de Creación:")
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm._f("date")(_vm.value.date)))
                      ])
                    ]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md-2 d-flex justify-content-end"
                      },
                      [
                        _c("drop-down", { attrs: { items: _vm.actions } }),
                        _vm.canReview
                          ? _c("action-button", {
                              staticClass: "ml-2",
                              attrs: {
                                i: "fas fa-flag",
                                variant: _vm.isDraft
                                  ? "outline-success"
                                  : "success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.review()
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("div", { staticClass: "w-100 px-3" }, [_c("hr")]),
                    _c("div", { staticClass: "col-12 col-md" }, [
                      _c("div", { staticClass: "data-name" }, [
                        _vm._v("Cantidad de Reclamaciones:")
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm._f("empty")(_vm.value.count)))
                      ])
                    ]),
                    _c("div", { staticClass: "col-12 col-md" }, [
                      _c("div", { staticClass: "data-name" }, [
                        _vm._v("Monto a Reclamar:")
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm._f("price")(_vm.value.totalAmount)))
                      ])
                    ]),
                    _c("div", { staticClass: "col-12 col-md" }, [
                      _c("div", { staticClass: "data-name" }, [
                        _vm._v("Lugar de Servicio:")
                      ]),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm._f("empty")(_vm.value.location?.name))
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "col-12 col-md-2" })
                  ]
                )
              ]),
              _vm.checkable
                ? _c(
                    "div",
                    [
                      _c("check-box", {
                        model: {
                          value: _vm.value.checked,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "checked", $$v)
                          },
                          expression: "value.checked"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm.canSendFile
        ? _c("error", {
            staticClass: "mt-0",
            attrs: {
              "is-alert-mode": "",
              message:
                "Batch procesado; falta enviar el archivo por SFTP, ya que ocurrió un error durante el proceso de envío."
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }